import { atomFamily } from "jotai/utils";

import { CityResponse } from "api/getCitiesByProvince";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionCountryOfAccidentAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`countryOfAccident-${sessionId}`, "" as string | null)
);
export const countryOfAccidentAtom = createDerivedSessionAtom<string | null>(sessionCountryOfAccidentAtom);

export const sessionProvinceOfAccidentAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`provinceOfAccident-${sessionId}`, "" as string | null)
);
export const provinceOfAccidentAtom = createDerivedSessionAtom<string | null>(sessionProvinceOfAccidentAtom);

export const sessionCityOfAccidentAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`cityOfAccident-${sessionId}`, null as CityResponse | null)
);
export const cityOfAccidentAtom = createDerivedSessionAtom<CityResponse | null>(sessionCityOfAccidentAtom);
